module.exports = __webpack_public_path__ + "static/media/yubikeyProcess.e67d1df3.svg";